// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
      .ngx-dropdown-container {
        width: 100%;
        position: relative;
        button {
          display: inline-block;
          margin-bottom: 0;
          line-height: 1.42857143;
          vertical-align: middle;
          touch-action: manipulation;
          cursor: pointer;
          -webkit-user-select: none;
                  user-select: none;
          border: 1px solid #ccc;
          border-radius: 4px;
          color: #333;
          background-color: #fff;
          white-space: nowrap;
          overflow-x: hidden;
          text-overflow: ellipsis;
          span {
            vertical-align: middle;
            float: left;
          }
          .nsdicon-angle-down {
            position: relative;
            font-size: large;
            float: right;
          }
        }
        .ngx-dropdown-button {
          font-family: 'Open Sans', sans-serif;
          font-size: 14px;
          color: #495057;
          width: 100%;
          min-height: 38px;
          padding: 5px 10px 5px 10px;
          background-color: white;
        }
        .ngx-dropdown-list-container {
          box-sizing: border-box;
          border: 1px solid rgba(0, 0, 0, 0.15);
          border-radius: 4px;
          padding-left: 10px;
          padding-right: 10px;
          z-index: 999999999;
          width: 350px;
          background-clip: padding-box;
          background: white;
          position: absolute;
          box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.21);
          overflow-y: auto;
          &.drop-up {
            bottom: 100%;
            top: auto;
            box-shadow: 5px -5px 5px 0px rgba(0, 0, 0, 0.21);
          }
          .search-container {
            position: relative;
            padding-top: 10px;
            margin-top: 5px;
            input {
              background-color: transparent;
              border: none;
              border-bottom: 1px solid #9e9e9e;
              border-radius: 0;
              outline: none;
              height: 2rem;
              width: 100%;
              font-size: 13px;
              margin: 0;
              padding: 0;
              box-shadow: none;
              box-sizing: content-box;
              transition: all 0.3s;
              &:focus {
                border-bottom: 1px solid #26a69a;
              }
              &:focus + label {
                transform: translateY(-2px) scale(0.8);
                transform-origin: 0 0;
              }
            }
            label {
              color: #9e9e9e;
              position: absolute;
              top: 0;
              left: 0;
              height: 100%;
              font-size: 1rem;
              cursor: text;
              transition: transform 0.2s ease-out;
              transform-origin: 0% 100%;
              text-align: initial;
              transform: translateY(12px);
              pointer-events: none;
              &.active {
                transform: translateY(-2px) scale(0.8);
                transform-origin: 0 0;
              }
            }
          }
          ul {
            margin-top: 1rem;
            margin-bottom: 1rem;
            list-style-type: none;
            padding-left: 0px;
            &.selected-items {
              li {
                background-color: #337ab7;
                color: white;
                margin-bottom: 2px;
              }
            }
            &.available-items {
              max-height: 390px;
              overflow-y: auto;
              li.active {
                background-color: #337ab7;
                color: #ffff;
              }
            }
            li {
              font-size: inherit;
              cursor: pointer;
              display: block;
              padding: 3px 20px;
              clear: both;
              font-weight: 400;
              line-height: 1.42857143;
              color: #333;
              white-space: normal;
            }
          }
        }
        .disabled {
          pointer-events: none;
          background-color: #e9ecef;
          opacity: 1;
          cursor: no-drop;
        }
      }
    `, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
